var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:{ 'text-bold': _vm.bold }},[_vm._v(_vm._s(_vm.value))]),(_vm.showError)?_c('w-error',{attrs:{"model":_vm.model}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }